import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReporteFormato2 from "../components/sustancias-reportes/ReporteFormato2";
import ReporteFormato1 from "../components/sustancias-reportes/ReporteFormato1";
import ReporteFormato3 from "../components/sustancias-reportes/ReporteFormato3";
import Faltantes from "../components/sustancias-reportes/Faltantes";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";

class ListaSustancias extends React.Component {
  initialState = {
    buscarReporte: {},

    tipo_reporte: Api.loadCatalogue("cat_sustancias_reporte"),

    nivelUsuario: localStorage.nivel_actual,
    establecimiento_id: "",
    mes_num: "",
    mes: "",
    tipo_reporte_id: "",
    productos_listado: [],
    establecimiento_razon_social: "",
    establecimientos_faltantes: [],
    data_reporte: "",
    reporte: "",

    openModalFormato1: false,
    openModalFormato2: false,
    openModalFormato3: false,
    openModalEstablecimientosFaltantes: false,

    //optiones_establecimiento: [],
    options_mes: [
      { id: "0", mes: "ENERO" },
      { id: "1", mes: "FEBRERO" },
      { id: "2", mes: "MARZO" },
      { id: "3", mes: "ABRIL" },
      { id: "4", mes: "MAYO" },
      { id: "5", mes: "JUNIO" },
      { id: "6", mes: "JULIO" },
      { id: "7", mes: "AGOSTO" },
      { id: "8", mes: "SEPTIEMBRE" },
      { id: "9", mes: "OCTUBRE" },
      { id: "10", mes: "NOVIEMBRE" },
      { id: "11", mes: "DICIEMBRE" },
    ],
    option_productos: [],
    reporte_1: {
      producto_id: "",
      cantidad: "",
      nom_producto: "",
      bitacora_id: "",
      no_factura_exportacion: "",
      no_certificado_exportacion: "",
      aduana: "",
      fecha_ingreso_aduana: "", // new Date().toISOString().slice(0, 10),
      fecha_exportador_aduana: "",
    },
    productos: [],
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.MostrarFormularios = this.MostrarFormularios.bind(this);
    this.handleCambioFormulario1 = this.handleCambioFormulario1.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.validarProductos = this.validarProductos.bind(this);
    this.addReporte1 = this.addReporte1.bind(this);
    this.limpiarEerror = this.limpiarEerror.bind(this);
    this.validarNumeroEnteroPositivo =
      this.validarNumeroEnteroPositivo.bind(this);
    this.validarNumeroFloatPositivo =
      this.validarNumeroFloatPositivo.bind(this);
    this.removeReporte1 = this.removeReporte1.bind(this);
    this.mostrarError = this.mostrarError.bind(this);
    this.handleCantidadGramosChange =
      this.handleCantidadGramosChange.bind(this);
    this.getDataReporteMedicamentoControlado =
      this.getDataReporteMedicamentoControlado.bind(this);
    this.generarReporteConsolidado = this.generarReporteConsolidado.bind(this);
    this.handleDesactivarReporte = this.handleDesactivarReporte.bind(this);
    this.handleSubmitConsolidado = this.handleSubmitConsolidado.bind(this);
    this.buscarEstablecimientosFaltantes =
      this.buscarEstablecimientosFaltantes.bind(this);
  }

  mi_grid = {};
  generar = {};
  generarReportesConsolidados = {};

  componentDidMount() {
    /* let optiones_establecimiento = [];
    Api.fetch( "app/getEstablecimientosRegRep").then((data) => {
      if(data){
         optiones_establecimiento = data;
      }
    }); */

    // si el usuario no es nivel cliente o drycip redireccionamos a home
    if (this.state.nivelUsuario !== "1" && this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    /**
     * Esta vista tambien funcionara para drycip
     */
    let source =
      "app/getReportesSustanciaMedicamentoControlado?nivel_usuario=" +
      this.state.nivelUsuario +
      "&";

    let gridCliente = {
      source: source,
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio: {
          label: "Folio",
        },
        razon_social: {
          label: "Establecimiento",
        },
        tipo_reporte: {
          label: "Tipo reporte",
        },
        mes: {
          label: "Mes",
          render: (me) => {
            let mes = this.state.options_mes.find(
              (d) => parseInt(d.id) + 1 === parseInt(me.data.mes) //revisar despues ya que va a depender de como lo guarde
            );
            if (this.state.nivelUsuario === "1") {
              me.innerHTML = mes.mes;
            }
          },
        },
        fecha_emision: {
          label: "Fecha de emisión",
          render: (me) => {
            me.innerHTML = me.data.fecha_emision
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        status: {
          label: "Estatus",
          render: (me) => {
            if (me.data.status === "0") {
              me.innerHTML = "INACTIVO";
            } else {
              me.innerHTML = "ACTIVO";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-download",
          btnClass: "btn btn-primary",
          tittle: "Descargar",
          download: "download",
          title: "Descargar Reporte",
          btnClick: (data) => {
            window.location.href =
              Api.url +
              `app/descargarReporteExcel/?id=${data.id}&tipo_id=${data.sustancia_reporte_id}`;
          },
          render: (me, data) => {},
        },
        {
          iconClass: "fa fa-times",
          btnClass: "btn bg-gradient-red",
          tittle: "Desactivar",
          btnClick: (data) => {
            this.handleDesactivarReporte(data);
          },
          render: (me, data) => {
            if (data.status === "0" || this.state.nivelUsuario === "3") {
              me.remove();
            }
          },
        },
      ],
    };

    let gridDRYCIP = {
      source: source,
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio: {
          label: "Folio",
        },
        tipo_reporte: {
          label: "Tipo reporte",
        },
        fecha_inicio: {
          label: "Fecha inicio",
          render: (me) => {
            me.innerHTML = me.data.fecha_inicio
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        fecha_fin: {
          label: "Fecha fin",
          render: (me) => {
            me.innerHTML = me.data.fecha_fin
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        fecha_emision: {
          label: "Fecha de emisión",
          render: (me) => {
            me.innerHTML = me.data.fecha_emision
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        status: {
          label: "Estatus",
          render: (me) => {
            if (me.data.status === "0") {
              me.innerHTML = "INACTIVO";
            } else {
              me.innerHTML = "ACTIVO";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-download",
          btnClass: "btn btn-primary",
          tittle: "Descargar",
          download: "download",
          title: "Descargar Reporte",
          btnClick: (data) => {
            window.location.href =
              Api.url +
              `app/descargarReporteExcel/?id=${data.id}&tipo_id=${data.sustancia_reporte_id}`;
          },
          render: (me, data) => {},
        },
        {
          iconClass: "fa fa-times",
          btnClass: "btn bg-gradient-red",
          tittle: "Desactivar",
          btnClick: (data) => {
            this.handleDesactivarReporte(data);
          },
          render: (me, data) => {
            if (data.status === "0" || this.state.nivelUsuario === "3") {
              me.remove();
            }
          },
        },
      ],
    };

    this.state.nivelUsuario === "1"
      ? (this.mi_grid = Api.grid(gridCliente))
      : (this.mi_grid = Api.grid(gridDRYCIP));

    let busquedaCliente = Api.form({
      target: "#busquedaCliente",
      render: (form) => {
        /** Cargamos el combo de establecimiento donde soy regente o representante 
        Api.fetch("app/getEstablecimientosRegRep").then((data) => {
          let cmbCE = `<option value="">Seleccione el establecimiento</option>`;
          if (data) {
            for (let o in data) {
              cmbCE += `<option value=${data[o].id}>${data[o].razon_social} [${data[o].folio_establecimiento}]</option>`;
            }
          }
          form.querySelector("#establecimiento_id").innerHTML = cmbCE;
        });
        /* let data = optiones_establecimiento;
          let cmbCE = `<option value="">Seleccione el establecimiento</option>`;
          for (let o in data) {
            cmbCE += `<option value=${data[o].id}>${data[o].razon_social} [${data[o].folio_establecimiento}]</option>`;
          }
          form.querySelector("#establecimiento_id").innerHTML = cmbCE; */
        /* Fin de la carga*/

        /** Cargamos el combo de tipo_reporte */
        let tipo_reporte = this.state.tipo_reporte;
        let reportes = [];

        if (this.state.nivelUsuario === "1") {
          reportes = ["1", "2", "3", "4"];
        } else if (this.state.nivelUsuario === "3") {
          reportes = ["5", "6"];
        }

        let option_t =
          "<option value=''>Seleccione el tipo de reporte</option>";

        for (let t in tipo_reporte) {
          if (reportes.includes(tipo_reporte[t].id)) {
            option_t += `<option value="${tipo_reporte[t].id}"> ${tipo_reporte[t].descripcion} </option>`;
          }
        }
        form.querySelector("#tipo_reporte").innerHTML = option_t;
        /* Fin de la carga tipo_reporte */

        /** Cargamos el combo de mes */
        let mes = this.state.options_mes;
        let option_m = "<option value=''>Seleccione el mes</option>";
        for (let m in mes) {
          option_m += `<option value="${mes[m].id}">${mes[m].mes}</option>`;
        }
        form.querySelector("#mes").innerHTML = option_m;
        /* Fin de la carga mes */
      },
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio",
            label: "Folio",
            placeHolder: "Folio",
            cols: 4,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "establecimiento",
            label: "Establecimiento",
            placeHolder: "Establecimiento",
            cols: 4,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "mes",
            label: "Mes",
            placeHolder: "Mes",
            cols: 4,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_reporte",
            label: "Tipo de reporte",
            placeHolder: "Tipo de reporte",
            cols: 3,
            value: "",
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 3,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarReporte: busquedaCliente.data() });
              let search = this.state.buscarReporte;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });

    let busquedaDRYCIP = Api.form({
      target: "#busquedaDRYCIP",
      render: (form) => {
        /** Cargamos el combo de establecimiento donde soy regente o representante 
        Api.fetch("app/getEstablecimientosRegRep").then((data) => {
          let cmbCE = `<option value="">Seleccione el establecimiento</option>`;
          if (data) {
            for (let o in data) {
              cmbCE += `<option value=${data[o].id}>${data[o].razon_social} [${data[o].folio_establecimiento}]</option>`;
            }
          }
          form.querySelector("#establecimiento_id").innerHTML = cmbCE;
        });
        /* let data = optiones_establecimiento;
          let cmbCE = `<option value="">Seleccione el establecimiento</option>`;
          for (let o in data) {
            cmbCE += `<option value=${data[o].id}>${data[o].razon_social} [${data[o].folio_establecimiento}]</option>`;
          }
          form.querySelector("#establecimiento_id").innerHTML = cmbCE; */
        /* Fin de la carga*/

        /** Cargamos el combo de tipo_reporte */
        let tipo_reporte = this.state.tipo_reporte;
        let reportes = [];

        if (this.state.nivelUsuario === "1") {
          reportes = ["1", "2", "3", "4"];
        } else if (this.state.nivelUsuario === "3") {
          reportes = ["5", "6"];
        }

        let option_t =
          "<option value=''>Seleccione el tipo de reporte</option>";

        for (let t in tipo_reporte) {
          if (reportes.includes(tipo_reporte[t].id)) {
            option_t += `<option value="${tipo_reporte[t].id}"> ${tipo_reporte[t].descripcion} </option>`;
          }
        }
        form.querySelector("#tipo_reporte").innerHTML = option_t;
        /* Fin de la carga tipo_reporte */

        /* Fin de la carga mes */
      },
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio",
            label: "Folio",
            placeHolder: "Folio",
            cols: 6,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_reporte",
            label: "Tipo de reporte",
            placeHolder: "Tipo de reporte",
            cols: 6,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha emisión desde",
            cols: 5,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha emisón hasta",
            cols: 5,
            value: "",
          },
        },

        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarReporte: busquedaDRYCIP.data() });
              let search = this.state.buscarReporte;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });

    this.generar = Api.form({
      target: "#generar",
      onchange: (me, data, serial) => {
        switch (me.name) {
          case "establecimiento":
            let selectEst = document.querySelector(".establecimiento_generar"),
              razonSocial = selectEst.options[selectEst.selectedIndex].text;

            this.setState({ establecimiento_razon_social: razonSocial });
            break;
          case "tipo_reporte":
            let tipo_reporte = document.querySelector(
              ".tipo_reporte_generar"
            ).value;

            let reporte = this.state.tipo_reporte.find(
              (r) => r.id === tipo_reporte
            );

            this.setState({ reporte });

            break;
          default:
        }
      },
      render: (form) => {
        /** Cargamos el combo de establecimiento donde soy regente o representante */
        Api.fetch("app/getEstablecimientosRegRep").then((data) => {
          let cmbCE = `<option value="">Seleccione el establecimiento</option>`;
          if (data) {
            for (let o in data) {
              cmbCE += `<option data-razon_social="${data[o].razon_social} [${data[o].folio_establecimiento}]" value=${data[o].id}>${data[o].razon_social} [${data[o].folio_establecimiento}]</option>`;
            }
          }
          form.querySelector("#establecimiento").innerHTML = cmbCE;
          form
            .querySelector("#establecimiento")
            .classList.add("establecimiento_generar");
        });

        /** Cargamos el combo de mes */
        let mes = this.state.options_mes;
        let option_m = "<option value=''>Seleccione el mes</option>";
        const fecha = new Date();
        const mesActual = fecha.getMonth();

        switch (true) {
          case mesActual === 0:
            mes = mes.slice(mesActual - 3);
            break;
          case mesActual === 1:
            mes = [
              { id: "10", mes: "NOVIEMBRE" },
              { id: "11", mes: "DICIEMBRE" },
              { id: "0", mes: "ENERO" },
            ];
            break;
          case mesActual === 2:
            mes = [
              { id: "11", mes: "DICIEMBRE" },
              { id: "0", mes: "ENERO" },
              { id: "1", mes: "FEBRERO" },
            ];
            break;
          default:
            mes = mes.slice(mesActual - 3, mesActual);
        }

        for (let m in mes) {
          option_m += `<option value="${mes[m].id}">${mes[m].mes}</option>`;
        }
        form.querySelector("#mes").innerHTML = option_m;
        /* Fin de la carga mes */

        /** Cargamos el combo de tipo_reporte */
        let tipo_reporte = this.state.tipo_reporte;
        let option_t =
          "<option value=''>Seleccione el tipo de reporte</option>";
        for (let t in tipo_reporte) {
          if (["1", "2", "3", "4"].includes(tipo_reporte[t].id)) {
            option_t += `<option value="${tipo_reporte[t].id}"> ${tipo_reporte[t].descripcion} </option>`;
          }
        }
        form.querySelector("#tipo_reporte").innerHTML = option_t;
        form
          .querySelector("#tipo_reporte")
          .classList.add("tipo_reporte_generar");
        /* Fin de la carga tipo_reporte */
      },
      elementClass: "form-control",
      elements: [
        {
          select: {
            type: "text",
            name: "establecimiento",
            label: "Establecimiento",
            placeHolder: "Establecimiento",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "mes",
            label: "Mes",
            placeHolder: "Mes",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_reporte",
            label: "Tipo de reporte",
            placeHolder: "Tipo de reporte",
            cols: 3,
            value: "",
          },
        },
        {
          button: {
            name: "btn_generar",
            class: "btn btn-success btn-block",
            //icon: "fa fa-search",
            cols: 3,
            text: "Generar",
            click: (e) => {
              /**se agrega la funcion para generar */
              this.MostrarFormularios(this.generar.data());
              //this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });

    this.generarReportesConsolidados = Api.form({
      target: "#generarReportesConsolidados",
      onchange: (me, data, serial) => {
        switch (me.name) {
          case "establecimiento":
            let selectEst = document.querySelector(".establecimiento_generar"),
              razonSocial = selectEst.options[selectEst.selectedIndex].text;

            this.setState({ establecimiento_razon_social: razonSocial });
            break;
          case "tipo_reporte":
            let tipo_reporte = document.querySelector(
              ".tipo_reporte_generar"
            ).value;

            let reporte = this.state.tipo_reporte.find(
              (r) => r.id === tipo_reporte
            );

            this.setState({ reporte });

            break;
          default:
        }
      },
      render: (form) => {
        /** Cargamos el combo de tipo_reporte */
        let tipo_reporte = this.state.tipo_reporte;
        let option_t =
          "<option value=''>Seleccione el tipo de reporte</option>";
        for (let t in tipo_reporte) {
          if (["5", "6"].includes(tipo_reporte[t].id)) {
            option_t += `<option value="${tipo_reporte[t].id}"> ${tipo_reporte[t].descripcion} </option>`;
          }
        }
        form.querySelector("#tipo_reporte").innerHTML = option_t;
        form
          .querySelector("#tipo_reporte")
          .classList.add("tipo_reporte_generar");
        /* Fin de la carga tipo_reporte */
      },
      elementClass: "form-control",
      elements: [
        {
          select: {
            type: "text",
            name: "tipo_reporte",
            label: "Tipo de reporte",
            placeHolder: "Tipo de reporte",
            cols: 4,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_desde",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_hasta",
            label: "Fecha hasta",
            max: `${new Date().toISOString().split("T")[0]}`,
            cols: 3,
            value: "",
          },
        },
        {
          button: {
            name: "btn_generarReportesConsolidados",
            class: "btn btn-success btn-block",
            //icon: "fa fa-search",
            cols: 2,
            text: "Generar",
            click: (e) => {
              /* Se llama función para generar reporte consolidado */
              let data = this.generarReportesConsolidados.data(),
                advertencias = 0;

              this.setState({ data_reporte: data });

              if (!data.fecha_hasta) {
                Swal.fire({
                  title: "Atención",
                  icon: "warning",
                  text: "Favor de seleccionar fecha fin",
                });
                advertencias++;
              }

              if (!data.fecha_desde) {
                Swal.fire({
                  title: "Atención",
                  icon: "warning",
                  text: "Favor de seleccionar fecha de inicio",
                });
                advertencias++;
              }

              if (!data.tipo_reporte) {
                Swal.fire({
                  title: "Atención",
                  icon: "warning",
                  text: "Favor de seleccionar tipo de reporte",
                });
                advertencias++;
              }

              if (data.fecha_desde && data.fecha_hasta) {
                let fechaHasta = new Date(data.fecha_hasta).getTime(),
                  fechaDesde = new Date(data.fecha_desde).getTime();

                if (fechaHasta <= fechaDesde) {
                  Swal.fire({
                    title: "Atención",
                    icon: "warning",
                    text: "Favor de verificar las fechas seleccionadas",
                  });
                  advertencias++;
                }
              }

              if (advertencias === 0) {
                Api.loading(true);
                Api.fetch(
                  "app/existeReporteConsolidado?tipo_reporte=" +
                    data.tipo_reporte +
                    "&fecha_inicio=" +
                    data.fecha_desde +
                    "&fecha_fin=" +
                    data.fecha_hasta
                ).then((res) => {
                  let title = "¿Está seguro que quiere generar el reporte?";

                  if (res.existe) {
                    title =
                      "Ya existe un reporte con esta información, ¿Desea generar el reporte?";

                    Swal.fire({
                      title: title,
                      icon: "question",
                      showCancelButton: true,
                      confirmButtonText: "Generar",
                      showLoaderOnConfirm: true,
                      reverseButtons: true,
                      confirmButtonColor: "#4CD964",
                      cancelButtonColor: "red",
                      cancelButtonText: "Cancelar",
                    }).then((res) => {
                      if (res.isConfirmed) {
                        this.buscarEstablecimientosFaltantes(data);
                      }
                    });
                  } else {
                    Api.loading(false);
                    this.buscarEstablecimientosFaltantes(data);
                  }
                });
              }
            },
          },
        },
      ],
    });
  }

  handleSubmitConsolidado() {
    Swal.fire({
      title: "¿Está seguro que quiere generar el reporte?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Generar",
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      cancelButtonText: "Cancelar",
    }).then((res) => {
      if (res.isConfirmed) {
        this.generarReporteConsolidado(this.state.data_reporte);
      }
    });
  }

  buscarEstablecimientosFaltantes(data) {
    Api.loading(true);
    Api.fetch(
      "app/getEstablecimientosSinReportesImportacion?tipo_reporte=" +
        data.tipo_reporte +
        "&fecha_inicio=" +
        data.fecha_desde +
        "&fecha_fin=" +
        data.fecha_hasta
    ).then((res) => {
      if (res.length > 0) {
        let option_meses = this.state.options_mes,
          mes_nombre = "";

        res.forEach((r) => {
          mes_nombre = option_meses.find(
            (op) => parseInt(op.id) === parseInt(r.mes) - 1
          );

          r["mes_nombre"] = mes_nombre.mes;
        });

        this.setState({
          establecimientos_faltantes: res,
          openModalEstablecimientosFaltantes: true,
        });

        Api.loading(false);
      } else {
        Swal.fire({
          title: "¿Está seguro que quiere generar el reporte?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Generar",
          confirmButtonColor: "#4CD964",
          cancelButtonColor: "red",
          showLoaderOnConfirm: true,
          reverseButtons: true,
          cancelButtonText: "Cancelar",
        }).then((res) => {
          if (res.isConfirmed) {
            this.generarReporteConsolidado(data);
          }
        });
      }
    });
  }

  MostrarFormularios(data) {
    let valido = 1;

    if (!data.tipo_reporte) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de seleccionar el tipo reporte",
      });
      valido = 0;
    }

    if (!data.mes) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de seleccionar el mes",
      });
      valido = 0;
    }

    if (!data.establecimiento) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de seleccionar el establecimiento",
      });
      valido = 0;
    }

    if (valido) {
      Api.loading(true);

      Api.fetch(
        "app/existeReporteMedicamentoControlado?tipo_reporte=" +
          data.tipo_reporte +
          "&mes=" +
          data.mes +
          "&establecimiento_id=" +
          data.establecimiento
      ).then((res) => {
        if (res.existe) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: res.message,
          });
        } else {
          Api.loading(false);
          let mes = this.state.options_mes.find(
            (d) => d.id.toString() === data.mes
          );
          this.setState({
            establecimiento_id: data.establecimiento,
            mes_num: data.mes,
            mes: mes.mes,
            tipo_reporte_id: data.tipo_reporte,
          });
          switch (data.tipo_reporte) {
            case "1":
              this.getDataReporteMedicamentoControlado();
              this.setState({
                openModalFormato1: true,
              });
              break;
            case "2":
              this.getDataReporteMedicamentoControlado(data);
              break;
            case "3":
              this.getDataReporteMedicamentoControlado(data);
              break;
            case "4":
              this.handleSubmit(data);
              break;
            default:
          }
        }
      });
    }
  }

  handleDesactivarReporte(data) {
    Swal.fire({
      title: "¿Está seguro que quiere desactivar el reporte?",
      showCancelButton: true,
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      confirmButtonText: "Desactivar",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);

        Api.fetch(
          "app/desactivarReporteMedicamentoControlado",
          {
            id: data.id,
          },
          "put"
        )
          .then((r) => {
            Api.loading(false);
            Swal.fire({
              icon: "success",
              title: r.message,
            });
            this.mi_grid.go(1);
          })
          .catch((error) => {
            error.json().then((message) => {
              Swal.fire({
                title: "Ocurrió un error al procesar la actividad",
                icon: "error",
                text: message,
              });
            }); //catching errors to show notification
          });
      }
    });
  }

  handleCambioFormulario1(e) {
    let r_1 = { ...this.state.reporte_1 };

    if (e.target.name === "bitacora_id") {
      r_1 = { ...this.initialState.reporte_1 };

      let p = this.state.option_productos.find(
        (d) => d.id.toString() === e.target.value
      );

      r_1["nom_producto"] = p.nombre_comercial;
      r_1["no_registro"] = p.no_registro;
      r_1["cantidad"] = p.cantidad;
      r_1["producto_id"] = p.producto_id;
    }

    r_1[e.target.name] = e.target.value.toUpperCase();
    this.setState({ reporte_1: r_1 });
  }

  addReporte1() {
    let r_1 = { ...this.state.reporte_1 };
    if (this.validarFormulario1(r_1)) {
      let lista_pro = [...this.state.productos];

      lista_pro.push(r_1);

      //tengo que quitar el producto de la lista
      let opt_pro = [...this.state.option_productos];
      for (let i in opt_pro) {
        if (
          parseInt(opt_pro[i].id) === parseInt(r_1.bitacora_id) &&
          parseInt(opt_pro[i].cantidad) === parseInt(r_1.cantidad)
        ) {
          opt_pro.splice(parseInt(i), 1);
          break;
        }
      }

      r_1 = { ...this.initialState.reporte_1 }; //limpio los campos'
      this.setState({
        reporte_1: r_1,
        productos: lista_pro,
        option_productos: opt_pro,
      });
    }
  }

  removeReporte1(e) {
    let id = parseInt(e.target.getAttribute("data-id"));
    let nombre = e.target.getAttribute("data-nombre");
    let cantidad = e.target.getAttribute("data-cantidad");
    let bitacora_id = e.target.getAttribute("data-bitacora_id");

    let lista_pro = [...this.state.productos];
    lista_pro.splice(e.target.id, 1);

    //agregamos de nuevo en el select
    let array = [...this.state.option_productos];
    let obj_pro = {
      id: bitacora_id,
      nombre_comercial: nombre,
      cantidad: cantidad,
      producto_id: id,
    };

    array.push(obj_pro);
    this.setState({ option_productos: array, productos: lista_pro });
  }

  validarFormulario1(data) {
    for (let d in data) {
      if (data[d] === "") {
        Swal.fire({
          title: "Atención",
          icon: "warning",
          text: "Favor de revisar el formulario.",
        });
        return 0;
      }
    }

    return 1;
  }

  generarReporteConsolidado(data) {
    Api.loading(true);
    let mesFechaDesde = data.fecha_desde.substring(5, 7),
      anioFechaDesde = new Date(data.fecha_desde).getFullYear(),
      mesFechaHasta = data.fecha_hasta.substring(5, 7),
      anioFechaHasta = new Date(data.fecha_hasta).getFullYear(),
      nombreReporte = this.state.reporte.titulo;

    let mesDesde = this.state.options_mes.find(
      (d) => parseInt(d.id) === parseInt(mesFechaDesde) - 1
    );

    let mesHasta = this.state.options_mes.find(
      (d) => parseInt(d.id) === parseInt(mesFechaHasta) - 1
    );

    data.numero_mes_desde = mesFechaDesde;
    data.nombre_mes_desde = mesDesde.mes;
    data.anio_mes_desde = anioFechaDesde;

    data.numero_mes_hasta = mesFechaHasta;
    data.nombre_mes_hasta = mesHasta.mes;
    data.anio_mes_hasta = anioFechaHasta;

    data.nombre_reporte = nombreReporte.toUpperCase();

    // data.fecha_desde_completa = data.fecha_desde;
    // data.fecha_hasta_completa = data.fecha_hasta;

    Api.fetch("app/generarReporteConsolidado", { data }, "POST").then((res) => {
      Api.loading(false);
      Swal.fire({
        icon: "success",
        title: res.message,
        //text: "Se generó reporte con éxito",
      });

      this.setState({
        establecimiento_id: this.initialState.establecimiento_id,
        establecimiento_razon_social:
          this.initialState.establecimiento_razon_social,
        mes_num: this.initialState.mes_num,
        mes: this.initialState.mes,
        tipo_reporte: this.initialState.tipo_reporte,
        openModalFormato3: this.initialState.openModalFormato3,
        openModalFormato2: this.initialState.openModalFormato2,
        openModalFormato1: this.initialState.openModalFormato1,
        productos: this.initialState.productos,
        data_reporte: this.initialState.data_reporte,
        reporte: this.initialState.reporte,
        establecimientos_faltantes:
          this.initialState.establecimientos_faltantes,
        openModalEstablecimientosFaltantes:
          this.initialState.openModalEstablecimientosFaltantes,
      });
      this.generar.clear();
      this.mi_grid.go(1);
    });
   }

  getDataReporteMedicamentoControlado() {
    Api.loading(true);

    let parametros = `?establecimiento_id=${this.state.establecimiento_id}&mes_num=${this.state.mes_num}&mes=${this.state.mes}&tipo_reporte=${this.state.tipo_reporte_id}`,
      option_productos = [],
      openModalFormato3 = false,
      openModalFormato2 = false;

    Api.fetch("app/getDataReporteMedicamentoControlado" + parametros)
      .then((data) => {
        Api.loading(false);
        if (this.state.tipo_reporte_id === "2") {
          // reporte 2
          option_productos = data;

          option_productos.length > 0
            ? (openModalFormato2 = true)
            : this.handleSubmit(data);
        } else if (this.state.tipo_reporte_id === "3") {
          // reporte 3
          option_productos = data;

          option_productos.length > 0
            ? (openModalFormato3 = true)
            : this.handleSubmit(data);
        } else if (["1", "4"].includes(this.state.tipo_reporte_id)) {
          // reporte 1 y 4
          option_productos = data;
        }

        this.setState({
          option_productos: option_productos,
          openModalFormato2: openModalFormato2,
          openModalFormato3: openModalFormato3,
        });
      })
      .then((res) => {
        if (
          (option_productos.length > 0 &&
            [("2", "3")].includes(this.state.tipo_reporte_id)) ||
          ["1", "4"].includes(this.state.tipo_reporte_id)
        ) {
          Api.loading(false);
        }
      });
  }

  mostrarError(error, msg) {
    document.getElementById(error + "-error").style.display = "block";
    document.getElementById(error + "-error").innerText = msg;
    document.getElementById(error).classList.add("is-invalid");
  }

  validarProductos() {
    let errores = 0,
      reporte = this.state.tipo_reporte_id;

    this.state.option_productos.forEach((prod, index) => {
      if (prod.gramos_devolucion === null || prod.gramos_devolucion === "") {
        errores += 1;
        let target = `gramos_devolucion-${index}`;
        this.mostrarError(target, "Ingrese gramos.");
      }

      if (
        reporte === "2" &&
        (prod.gramos_entrada === null || prod.gramos_entrada === "")
      ) {
        errores += 1;
        let target = `gramos_entrada-${index}`;
        this.mostrarError(target, "Ingrese gramos.");
      }

      if (
        reporte === "2" &&
        (prod.gramos_exportado === null || prod.gramos_exportado === "")
      ) {
        errores += 1;
        let target = `gramos_exportado-${index}`;
        this.mostrarError(target, "Ingrese gramos.");
      }

      if (
        reporte === "2" &&
        (prod.cantidad_deterioro === null || prod.cantidad_deterioro === "")
      ) {
        errores += 1;
        let target = `cantidad_deterioro-${index}`;
        this.mostrarError(target, "Ingrese gramos.");
      }

      if (prod.gramos_deterioro === null || prod.gramos_deterioro === "") {
        errores += 1;
        let target = `gramos_deterioro-${index}`;
        this.mostrarError(target, "Ingrese gramos.");
      }

      if (
        reporte === "3" &&
        (prod.gramos_importado === null || prod.gramos_importado === "")
      ) {
        errores += 1;
        let target = `gramos_importado-${index}`;
        this.mostrarError(target, "Ingrese gramos.");
      }

      if (prod.gramos_ventas === null || prod.gramos_ventas === "") {
        errores += 1;
        let target = `gramos_ventas-${index}`;
        this.mostrarError(target, "Ingrese gramos.");
      }

      if (
        prod.gramos_existencia_actual === null ||
        prod.gramos_existencia_actual === ""
      ) {
        errores += 1;
        let target = `gramos_existencia_actual-${index}`;
        this.mostrarError(target, "Ingrese gramos.");
      }
    });

    return errores;
  }

  // fn para limpar errores cuando cambie el estado del input que los tenga
  limpiarEerror(elemento) {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  }

  handleSubmit(e) {
    if (
      this.state.tipo_reporte_id === "1" &&
      this.state.productos.length === 0
    ) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de asignar a un producto como minímo la información.",
      });
      return;
    }

    Swal.fire({
      title:
        "¿Está seguro que quiere generar el reporte para medicamentos controlados?",
      showCancelButton: true,
      confirmButtonText: "Generar",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        if (["2", "3"].includes(this.state.tipo_reporte_id)) {
          let errores = this.validarProductos();
          if (errores > 0) return false;
        }

        Api.loading(true);

        let productos = null;

        if (["1", "4"].includes(this.state.tipo_reporte_id)) {
          productos = this.state.productos;
        } else if (["2", "3"].includes(this.state.tipo_reporte_id)) {
          productos = this.state.option_productos;
        }

        Api.fetch(
          "app/generarReporteMedicamentoControlado",
          {
            establecimiento_id: this.state.establecimiento_id,
            mes_num: this.state.mes_num,
            mes: this.state.mes,
            tipo_reporte: this.state.tipo_reporte_id,
            productos: productos,
            nombre_reporte: this.state.reporte.titulo,
          },
          "POST"
        )
          .then((r) => {
            Api.loading(false);
            Swal.fire({
              icon: "success",
              title: r.message,
              //text: "Se generó reporte con éxito",
            });

            this.setState({
              establecimiento_id: this.initialState.establecimiento_id,
              establecimiento_razon_social:
                this.initialState.establecimiento_razon_social,
              mes_num: this.initialState.mes_num,
              mes: this.initialState.mes,
              tipo_reporte: this.initialState.tipo_reporte,
              openModalFormato3: this.initialState.openModalFormato3,
              openModalFormato2: this.initialState.openModalFormato2,
              openModalFormato1: this.initialState.openModalFormato1,
              productos: this.initialState.productos,
            });
            this.generar.clear();
            this.mi_grid.go(1);
          })
          .catch((error) => {
            error.json().then((message) => {
              Swal.fire({
                title: "Ocurrió un error al procesar la actividad",
                icon: "error",
                text: message.message,
              });
            }); //catching errors to show notification
          });
      }
    });
  }

  validarNumeroFloatPositivo(str) {
    // let regex = /^[0-9]*(?:\.[0-9]{0,3})?$/,
    let regex = /^([0]?||[1-9]\d{0,2}(\d{3})*|([1-9]\d*))(\.\d{0,3})?$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }
    return response;
  }

  validarNumeroEnteroPositivo(char) {
    let regex = /^([0]?|[1-9]+[0]{0,9})$/;
    if (char === "" || regex.test(char)) {
      return true;
    }

    return false;
  }

  handleCantidadGramosChange(e) {
    let targetID = e.target.id,
      targetName = targetID.split("-")[0],
      targetIndex = targetID.split("-")[1],
      targetValue = e.target.value,
      productosListado = this.state.option_productos;

    switch (targetName) {
      case "gramos_devolucion":
        if (this.validarNumeroFloatPositivo(targetValue) === true) {
          this.limpiarEerror(targetID);
          productosListado[targetIndex].gramos_devolucion = targetValue;
        }
        break;
      case "cantidad_devolucion":
        if (this.validarNumeroEnteroPositivo(targetValue)) {
          this.limpiarEerror(targetID);
          productosListado[targetIndex].cantidad_devolucion = targetValue;
        }
        break;
      case "cantidad_deterioro":
        if (this.validarNumeroEnteroPositivo(targetValue)) {
          this.limpiarEerror(targetID);
          productosListado[targetIndex].cantidad_deterioro = targetValue;
        }
        break;

      case "gramos_importado":
        if (
          this.state.tipo_reporte_id === "3" &&
          this.validarNumeroFloatPositivo(targetValue)
        ) {
          this.limpiarEerror(targetID);
          productosListado[targetIndex].gramos_importado = targetValue;
        }
        break;
      case "gramos_deterioro":
        if (this.validarNumeroFloatPositivo(targetValue)) {
          this.limpiarEerror(targetID);
          productosListado[targetIndex].gramos_deterioro = targetValue;
        }
        break;
      case "gramos_ventas":
        if (this.validarNumeroFloatPositivo(targetValue)) {
          this.limpiarEerror(targetID);
          productosListado[targetIndex].gramos_ventas = targetValue;
        }
        break;
      case "gramos_existencia_actual":
        if (this.validarNumeroFloatPositivo(targetValue)) {
          this.limpiarEerror(targetID);
          productosListado[targetIndex].gramos_existencia_actual = targetValue;
        }
        break;
      case "gramos_entrada":
        if (this.validarNumeroFloatPositivo(targetValue)) {
          this.limpiarEerror(targetID);
          productosListado[targetIndex].gramos_entrada = targetValue;
        }
        break;
      case "gramos_exportado":
        if (this.validarNumeroFloatPositivo(targetValue)) {
          this.limpiarEerror(targetID);
          productosListado[targetIndex].gramos_exportado = targetValue;
        }
        break;

      default:
        break;
    }
    this.setState({ option_productos: productosListado });
  }

  closeModal(t_reporte) {
    Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.generar.clear();
        switch (t_reporte) {
          case 0:
            this.setState({
              openModalEstablecimientosFaltantes:
                this.initialState.openModalEstablecimientosFaltantes,
              data_reporte: this.initialState.data_reporte,
              reporte: this.initialState.reporte,
              establecimientos_faltantes:
                this.initialState.establecimientos_faltantes,
            });
            break;
          case 1:
            //limpio los campos
            let r_1 = { ...this.state.reporte_1 };
            let lista_pro = [...this.state.productos];
            r_1 = this.initialState.reporte_1;
            lista_pro = this.initialState.productos;

            this.setState({
              openModalFormato1: false,
              productos: lista_pro,
              reporte_1: r_1,
            });
            break;
          case 2:
            this.setState({
              openModalFormato2: this.initialState.openModalFormato2,
            });
            break;
          case 3:
            this.setState({
              option_productos: this.initialState.option_productos,
              productos_listado: this.initialState.productos_listado,
              openModalFormato3: this.initialState.openModalFormato3,
            });
            break;
          default:
        }
      }
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/reportes-importacion">Reportes</Link>
          </li>
          <li className="breadcrumb-item">Reportes medicamentos controlados</li>
        </ol>
        <h1 className="page-header">Reportes medicamentos controlados</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                {this.state.nivelUsuario === "1" ? (
                  <>
                    <fieldset>
                      <div id="busquedaCliente"></div>
                    </fieldset>
                    <fieldset>
                      <div id="generar"></div>
                    </fieldset>
                  </>
                ) : this.state.nivelUsuario === "3" ? (
                  <>
                    <fieldset>
                      <div id="busquedaDRYCIP"></div>
                    </fieldset>
                    <fieldset>
                      <div id="generarReportesConsolidados"></div>
                    </fieldset>
                  </>
                ) : null}

                <div id="myGrid"></div>
                <Modal
                  isOpen={this.state.openModalFormato1}
                  tabIndex="-1"
                  style={{
                    maxWidth: "100%",
                    width: "80%",
                  }}
                >
                  <ModalHeader
                    width="100%"
                    toggle={(e) => {
                      this.closeModal(1);
                    }}
                    className="text-center"
                  >
                    {this.state.reporte.descripcion || "N/A"}
                  </ModalHeader>
                  <ModalBody>
                    <form id="sustancia-formato-1" onSubmit={this.handleSubmit}>
                      <ReporteFormato1 component={this} state={this.state} />
                    </form>
                  </ModalBody>
                  <ModalFooter>
                    <div className="container p-0">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="btn-group pull-right col-md-3">
                            <button
                              className="btn btn-danger"
                              onClick={(e) => {
                                this.closeModal(1);
                              }}
                            >
                              Regresar
                            </button>

                            <button
                              onClick={this.handleSubmit}
                              value="5"
                              id="aprobar_form"
                              className="btn btn-success "
                            >
                              Aceptar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>

                <Modal
                  isOpen={this.state.openModalFormato2}
                  tabIndex="-1"
                  style={{
                    maxWidth: "100%",
                    width: "90%",
                  }}
                >
                  <ModalHeader
                    width="100%"
                    toggle={(e) => {
                      this.closeModal(2);
                    }}
                    className="text-center"
                  >
                    {this.state.reporte.descripcion || "N/A"}
                  </ModalHeader>
                  <ModalBody>
                    <form id="sustancia-formato-2" onSubmit={this.handleSubmit}>
                      <ReporteFormato2
                        state={this.state}
                        handleCantidadGramosChange={
                          this.handleCantidadGramosChange
                        }
                      />
                    </form>
                  </ModalBody>
                  <ModalFooter>
                    <div className="container p-0">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="btn-group pull-right col-md-3">
                            <button
                              className="btn btn-danger"
                              onClick={(e) => {
                                this.closeModal(2);
                              }}
                            >
                              Regresar
                            </button>

                            <button
                              onClick={this.handleSubmit}
                              value="5"
                              id="aprobar_form"
                              className="btn btn-success "
                            >
                              Aceptar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>

                <Modal
                  isOpen={this.state.openModalFormato3}
                  tabIndex="-1"
                  style={{
                    maxWidth: "100%",
                    width: "90%",
                  }}
                >
                  <ModalHeader
                    width="100%"
                    toggle={(e) => {
                      this.closeModal(3);
                    }}
                    className="text-center"
                  >
                    {this.state.reporte.descripcion || "N/A"}
                  </ModalHeader>
                  <ModalBody>
                    <form id="sustancia-formato-3" onSubmit={this.handleSubmit}>
                      <ReporteFormato3
                        state={this.state}
                        handleCantidadGramosChange={
                          this.handleCantidadGramosChange
                        }
                      />
                    </form>
                  </ModalBody>
                  <ModalFooter>
                    <div className="container p-0">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="btn-group pull-right col-md-3">
                            <button
                              className="btn btn-danger"
                              onClick={(e) => {
                                this.closeModal(3);
                              }}
                            >
                              Regresar
                            </button>

                            <button
                              onClick={this.handleSubmit}
                              value="5"
                              id="aprobar_form"
                              className="btn btn-success "
                            >
                              Aceptar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>

                <Modal
                  isOpen={this.state.openModalEstablecimientosFaltantes}
                  tabIndex="-1"
                  style={{
                    maxWidth: "100%",
                    width: "90%",
                  }}
                >
                  <ModalHeader
                    width="100%"
                    toggle={(e) => {
                      this.closeModal(0);
                    }}
                    className="text-center"
                  >
                    FALTANTES DE {this.state.reporte.descripcion || "N/A"}
                  </ModalHeader>
                  <ModalBody>
                    <form
                      id="establecimientos_reportes"
                      onSubmit={this.handleSubmitConsolidado}
                    >
                      <Faltantes state={this.state} />
                    </form>
                  </ModalBody>
                  <ModalFooter>
                    <div className="container p-0">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="btn-group pull-right col-md-3">
                            <button
                              className="btn btn-danger"
                              onClick={(e) => {
                                this.closeModal(0);
                              }}
                            >
                              Regresar
                            </button>

                            <button
                              onClick={this.handleSubmitConsolidado}
                              value="5"
                              id="aprobar_form"
                              className="btn btn-success "
                            >
                              Aceptar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

export default ListaSustancias;
